import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import store from '../../../store';
import {getValueOfFeature} from '../../../util/values';

import {selectHasBase, selectHasBuriedBase, selectIsSingle} from '../../../selectors';

@customElement('line-drawing')
export class LineDrawing extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		flex-direction: column;
	  }

	  @media (min-width: 768px) {
		/*bp-medium*/
		:host {
		  flex-direction: row;
		}
	  }

	  .drawing-container {
		display: flex;
		margin-right: 12em;
	  }

	  .grounding {
		position: relative;
		width: 160px;
		font: var(--font-specsheet-light);
	  }

	  .grounding-image {
		width: 100%;
		height: auto;
		margin-bottom: var(--specsheet-small-gap);
	  }
	  .single-image {
		width: 240px;
		height: auto;
		margin-bottom: var(--specsheet-small-gap);
	  }
	  @media print {
		:host {
		  flex-direction: row;
		}

		.drawing-container {
		  margin-right: 3cm;
		}

		.grounding {
		  position: relative;
		  width: 3cm;
		  height: 3cm;
		  font: var(--font-specsheet-print-light);
		}

		.grounding-image {
		  width: 100%;
		  height: auto;
		  margin-bottom: var(--specsheet-print-small-gap);;
		}
		.single-image {
		  width: 4cm;
		  height: auto;
		  margin-bottom: var(--specsheet-print-small-gap);;
		}
	  }
	`
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.decisions = state.decisions.data;
	}


	render() {
		const s = this.state;
		return html`

			<div class="drawing-container">
				${when(!selectIsSingle(s), () => html`
					<svg-measure></svg-measure>
				`)}
				${when(selectIsSingle(s), () => html`
					<img class="single-image" alt=""
						 src="${this.status.host + this.status.baseUrl + this.status.epimAssetsUrl}/images/line-single/${getValueOfFeature('HS_HousingType', this.decisions)}-${getValueOfFeature('HS_ModuleCutoutSize_1', this.decisions)}.svg"/>
				`)}
			</div>
			<div class="grounding-container">
				${when(!selectIsSingle(s) && selectHasBase(s) && !selectHasBuriedBase(s), () => html`
					<div class="grounding">
						<img class="grounding-image" alt=""
							 src="${this.status.host + this.status.baseUrl + this.status.epimAssetsUrl}/images/line-drawing/${getValueOfFeature('HS_Base', this.decisions)}.svg"/>
						<trans-label key="HS_Base" context="FV.S"></trans-label>
					</div>
				`)}
			</div>
		`;
	}
}
